<template>
    <div>
        <v-container grid-list-md justify-start>
            <v-layout>
                <v-flex xs12>
                    <div class="title mb-2">Statistics</div>
                    <v-divider></v-divider>
                </v-flex>
            </v-layout>
        </v-container>
        <statistics-grid></statistics-grid>
    </div>
</template>

<script>
import StatisticsGrid from './StatisticsGrid.vue'

export default {
    name: 'Statistics',
    data() {
        return {
        }
    },
    components: {
        StatisticsGrid
    }
}
</script>

<style scoped></style>
